import { gsap } from "gsap";

document.querySelectorAll(".real-marquee").forEach((marquee) => {
  const track = marquee.querySelector(".marquee-track");

  // Check if track exists
  if (!track) {
    console.warn('Marquee track not found in:', marquee);
    return;
  }

  // Get the width of a single set of items before duplication
  const firstSetWidth = track.scrollWidth;

  // Duplicate content for seamless loop
  track.innerHTML += track.innerHTML;

  // Calculate distance based on the first set width
  // This ensures a perfect loop without gaps
  const distance = firstSetWidth;

  gsap.to(track, {
    x: -distance,
    duration: 40, // global speed
    ease: "linear",
    repeat: -1
  });
});
